<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
      <span />
    </div>
    <div class="container container-lg pt-5">
      <card shadow>
        <div class="search-noresults">
          <section class="normal markdown-section">
            <div class="display-4 mb-4">Quantumult（推荐）</div>
            <ul>
              <li>系统要求：iOS 9 及以上</li>
              <li>设备要求：iPhone / iPad</li>
              <li>此应用已在国区下架，请使用非国区 Apple ID 下载。</li>
              <li>
                我们为绑定非国区支付方式困难的订阅客户准备了下载帐户，请购买服务后点击下方按钮
                《获取外区 Apple ID》
              </li>
            </ul>
            <div class="display-4 mt-4 mb-4">介绍</div>
            <p>
              Quantumult是目前iOS上支持较好用的客户端，支持订阅功能，但设置略复杂
            </p>
            <div class="display-4 mt-4 mb-4">下载</div>
            <!-- <p>版本: 2.2.50</p> -->
            <hr />
            <div
              style="white-space: pre-wrap; overflow-wrap: break-word; user-select: none; cursor: text; will-change: opacity; padding-left: 0px; padding-right: 0px;"
            >
              <div
                class="mb-4"
                style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
              >
                <span
                  ><span
                    style="font-weight: bold; font-size: 20px; color: rgb(136, 153, 168); background-color: rgb(255, 255, 255); font-family: Arial;"
                    >如果您的iPhone或iPad已經有Quantumult(圈)APP，請直接跳到第6步驟操作，沒有的請從第1步開始操作。</span
                  ></span
                >
              </div>
              <div
                class="mb-4"
                style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
              >
                <span
                  ><span
                    style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(211, 61, 61); background-color: rgb(253, 195, 137);"
                    >★安裝前必看：</span
                  ><span
                    style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(211, 61, 61); background-color: rgb(253, 195, 137);"
                    >切記千萬不要在手機的「設置」登入，請按照以下步驟一步一步操作，操作有問題請聯繫客服協助處理，下載完成請務必登回自己的ID。</span
                  ></span
                >
              </div>
              <div
                v-for="i in 3"
                :key="i"
                class="mb-2"
                style="font-weight: bold; font-size: 20px;"
              >
                <span
                  ><span
                    style="font-weight: bold; font-size: 20px; color: rgb(0, 0, 0); background-color: rgb(145, 234, 191);"
                    >★</span
                  ><span
                    style="font-weight: bold; font-size: 20px; color: rgb(0, 0, 0); background-color: rgb(145, 234, 191);"
                    >切記：千萬不要在手機的「設置」登入，否則鎖機不負責。</span
                  ></span
                >
              </div>
              <div style="font-weight: bold; font-size: 20px;">
                <span
                  ><span
                    style="font-weight: bold; font-size: 20px; color: rgb(211, 61, 61); background-color: rgb(255, 204, 203);"
                    >★</span
                  ><span
                    style="font-weight: bold; font-size: 20px; color: rgb(211, 61, 61); background-color: rgb(255, 204, 203);"
                    >最後提醒一次：請一定一定一定要按照以下操作，每個畫面都有固定的操作，不要擅自操作。</span
                  ></span
                >
              </div>
              <div>
                <hr />
              </div>
              <div
                style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
              >
                <span
                  ><span
                    style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(115, 92, 255); background-color: rgb(218, 212, 255);"
                    >以上看完沒問題後，再開始往下操作</span
                  ></span
                >
              </div>
              <div>
                <hr />
              </div>
              <div
                style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
              >
                <span
                  ><span
                    style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                    >1.進入App Store</span
                  ></span
                >
              </div>
              <div>
                <div>
                  <img alt="" src="@/assets/images/ios/appstore.jpg" style="width: 604px;" />
                </div>
              </div>
              <div
                class="mb-2"
                style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
              >
                <span
                  ><span
                    style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                    >2.點擊右上角頭像，然後再往下滑到最底按登出，按登出後滑到最上面</span
                  ></span
                >
              </div>
              <div>
                <img
                  alt=""
                  src="@/assets/images/ios/logout.jpg"
                  style="width: 604px;"
                />
              </div>

              <div
                style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
              >
                <span
                  ><span
                    style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                    >3.</span
                  ><span
                    style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                    >輸入Quantumult App的ID和密碼(ID密碼在下面)</span
                  ></span
                >
                <iframe
                  id="iframeContain"
                  name="iframeContain"
                  seamless
                  scrolling="yes"
                  :src="appleinfo"
                >
                  您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
                </iframe>
                <div>
                  <img
                    alt=""
                    src="@/assets/images/ios/password.jpg"
                    style="width: 604px;"
                  />
                </div>
              </div>
              <div style="font-weight: bold; font-size: 20px;">
                <span
                  ><span
                    style="font-weight: bold; font-size: 20px; color: rgb(0, 0, 0); background-color: rgb(145, 234, 191);"
                    >特別注意：</span
                  ><span
                    style="font-weight: bold; font-size: 20px; color: rgb(0, 0, 0); background-color: rgb(145, 234, 191);"
                    >登录后不要按「继续」，记得点击「其他选项」和「不要升级」</span
                  ></span
                >
              </div>

              <div style="font-weight: bold; font-size: 20px;">
                <span
                  ><span
                    style="font-weight: bold; font-size: 20px; color: rgb(211, 61, 61); background-color: inherit;"
                    >重要提醒：登录后不要按「继续」，记得点击「其他选项」和「不要升级」</span
                  ></span
                >
              </div>
              <div>
                <span
                  >登录后不要按「继续」，记得点击「其他选项」和「不要升级」</span
                >
              </div>

              <div>
                <span
                  >登录后不要按「继续」，记得点击「其他选项」和「不要升级」</span
                >
              </div>
              <div>
                <span
                  ><span
                    style="font-weight: bold; font-size: 20px; color: rgb(211, 61, 61); background-color: inherit;"
                    >重要提醒：登录后不要按「继续」，记得点击「其他选项」和「不要升级」</span
                  ></span
                >
              </div>
              <div
                style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
              >
                <span
                  ><span
                    style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                    >4.登錄後會出現安全認證，記得點擊「其他選項」和「不要升級」如下圖</span
                  ></span
                >
              </div>
              <div>
                <img
                  alt=""
                  src="@/assets/images/ios/iOS144.jpg"
                  style="width: 604px;"
                />
              </div>
              <div
                style="font-weight: bold; font-size: 22px;margin-bottom: 16px;"
              >
                <span
                  ><span
                    style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                    >5.點擊</span
                  ><span
                    style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                    >入「已購項目」，再點擊「小雲朵」去下載</span
                  ><span
                    style="font-weight: bold; font-size: 22px;margin-bottom: 16px; color: rgb(0, 0, 0); background-color: rgb(255, 204, 203);"
                    >Quantumult</span
                  ></span
                >
                <div>
                  <img
                    alt=""
                    src="@/assets/images/ios/yigou.jpg"
                    style="width: 604px;"
                  />
                </div>
              </div>
            </div>
            <p style="margin: 3px 0;font-weight: bold;margin:0;font-size: 14px;">为防止滥用我们未公布该密码，请预先购买套餐后，获取您的Apple ID。(如果购买后，上面按钮不能点击，请刷新后重试)</p>
            <div class="display-4 mt-4 mb-4">订阅信息</div>
            <div v-if="accounts.length">
              <div
                v-for="account in accounts"
                :key="account._id"
                class="sub-item mb-2"
              >
                <div class="display-6 mt-2 mb-2">
                  {{ account.product.title }}
                </div>
                <base-button
                  class=" mr-3"
                  size="sm"
                  type="primary"
                  @click="
                    handleCopy(
                      `${subLinks_1}/v1/api/quan/${account.subscription ||
                        account._id}`,
                      $event
                    )
                  "
                  >点我复制订阅连接1</base-button
                >
                <!-- <base-button
                  size="sm"
                  type="primary"
                  @click="
                    handleCopy(
                      `${subLinks_2}/v1/api/quan/${account.subscription ||
                        account._id}`,
                      $event
                    )
                  "
                  >点我复制订阅连接2</base-button
                > -->
                <base-button
                  class=" mr-3"
                  size="sm"
                  type="error"
                  @click="
                    addSub(
                      `https://www.lles.me/v1/api/quan/${account.subscription ||
                        account._id}?me=6`,
                      $event
                    )
                  "
                  >一键导入配置订阅</base-button
                >
              </div>
            </div>
            <div v-else>
              <h2 class="display-4" style="font-size: 1.2rem">
                你还没有套餐，
                <router-link :to="{ name: 'dashboard-plan' }"
                  >立即购买</router-link
                >
              </h2>
            </div>
            <div class="display-4 mt-4 mb-4">设置订阅</div>

            <ul>
              <li>
                点击上面按钮，粘贴订阅连接，打开Quantumult，
                <strong>设置</strong>选项卡，点击
                <strong>订阅</strong>
              </li>
            </ul>
            <p>
              <img src="/img/client/ios/quantumult/image-4.png" alt />
            </p>
            <ul>
              <li>
                打开菜单里，点击
                <strong>右上+号</strong>，弹出菜单选择
                <strong>服务器</strong>
              </li>
            </ul>
            <p>
              <img src="/img/client/ios/quantumult/image-92.png" alt />
            </p>
            <ul>
              <li>
                打开的服务器信息窗口中，
                <strong>链接</strong>位置粘贴
                <strong>Quantumult专用链</strong>，并打开
                <strong>更新检测</strong>并
                <strong>保存</strong
                >。Quantumult会自动下载套餐对应的服务器节点信息
              </li>
            </ul>
            <p>
              <img src="/img/client/ios/quantumult/image%20%2829%29.png" alt />
            </p>
            <ul>
              <li>
                点击Quantumult
                Logo图标，可以看到所有节点并自由切换，带有简易的延迟测试
              </li>
            </ul>
            <p>
              <img src="/img/client/ios/quantumult/image%20%2844%29.png" alt />
            </p>
            <p>
              <img src="/img/client/ios/quantumult/image%20%2841%29.png" alt />
            </p>
            <ul>
              <li>
                选中节点后，点击
                <strong>首页</strong>选项卡，打开
                <strong>右上角开关</strong>即可开启代理
              </li>
            </ul>
            <p>
              <img src="/img/client/ios/quantumult/image-7.png" alt />
            </p>
            <ul>
              <li>
                首次使用系统会提示配置VPN，允许后需要使用指纹/Face ID/密码 确认
              </li>
            </ul>
            <p>
              <img src="/img/client/ios/quantumult/image-30.png" alt />
            </p>
            <p>
              <img src="/img/client/ios/quantumult/image-40.png" alt />
            </p>
            <!-- <h2 id="可选配置---规则订阅">可选配置 - 规则订阅</h2> -->
            <!-- <ul>
              <li>
                Quantumult内置了一个分流规则，大部分情况效果不错，但是还是会有规则匹配不正确的情况用户可以选择自定义更为完善的规则。
              </li>
              <li>
                规则仅在
                <strong>运行模式 - 自动分流</strong>模式下生效
              </li>
              <li>
                推荐规则：
                <a href="https://github.com/lhie1/Rules" target="_blank"
                  >lhie1规则</a
                >。目前维护最为完善的规则，包含了分流策略，去广告，拦截隐私跟踪等功能
              </li>
              <li>
                订阅地址：
                <ul>
                  <li>
                    分流规则：
                    <a
                      href="https://raw.githubusercontent.com/lhie1/Rules/master/Quantumult/Quantumult.conf"
                      target="_blank"
                      >https://raw.githubusercontent.com/lhie1/Rules/master/Quantumult/Quantumult.conf</a
                    >
                  </li>
                  <li>
                    阻止规则：
                    <a
                      href="https://raw.githubusercontent.com/lhie1/Rules/master/Quantumult/Quantumult_URL.conf"
                      target="_blank"
                      >https://raw.githubusercontent.com/lhie1/Rules/master/Quantumult/Quantumult_URL.conf</a
                    >
                  </li>
                </ul>
              </li>
              <li>
                <strong>设置</strong>选项卡，点击 <strong>订阅</strong>，
                <strong>右上角+号</strong
                >，和设置服务器订阅一样分别设置分流规则和链接阻止规则
              </li>
            </ul> -->
            <!-- <p>
              <img src="/img/client/ios/quantumult/image%20%2815%29.png" alt />
            </p> -->
            <!-- <ul>
              <li>
                在两条订阅规则上分别向左滑，点击
                <strong>替换</strong>
              </li>
            </ul>
            <p>
              <img src="/img/client/ios/quantumult/image-39.png" alt />
            </p>
            <ul>
              <li>
                更新分流规则时，系统会提供选项自定义规则，根据提示选择后保存即可
              </li>
            </ul> -->
            <!-- <p>
              <img src="/img/client/ios/quantumult/image-11.png" alt />
            </p> -->
          </section>
        </div>
      </card>
    </div>
    <!-- <modal :show.sync="modal" modal-classes=" modal-dialog-centered" modal-sm>
      <template slot="header">
        <h5 class="modal-title">软件 Quantumult 下载 Apple ID</h5>
      </template>
      <apple-content v-if="modal" :info="appleinfo" />
      <p style="margin: 3px 0;font-weight: bold;margin:0;font-size: 14px;">
        4. 登录成功后，打开App Stoe 搜索关键字 《Quantumult》，下载应用
      </p>
      <p style="margin: 3px 0;font-weight: bold;margin:0;font-size: 14px;">
        5. 软件下载完成后，回到这个页面点击下面按钮，一键导入订阅配置
      </p>
      <p style="font-weight: bold;color: red;margin:6px 0;font-size: 14px;">
        6. 如果显示收费，直接购买下载即可。
      </p>
      <div v-if="accounts.length">
        <div v-for="account in accounts" :key="account._id" class="sub-item mb-2">
          <div class="display-6 mt-2 mb-2">{{ account.product.title }}</div>
          <base-button class=" mr-3" size="sm" type="primary" @click="addSub(`https://www.lles.me/v1/api/quan/${account.subscription || account._id }`)" >一键导入配置订阅</base-button>
        </div>
      </div>
      <p style="margin: 3px 0;font-weight: bold;margin:0;font-size: 14px;">
        6. 成功导入配置后，直接开启开关，允许权限就可以使用了
      </p>
    </modal> -->
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import clip from '@/utils/clipboard'
import Modal from '@/components/Modal.vue'
import AppleContent from '@/components/AppleContent.vue'
import BProgress from 'bootstrap-vue/es/components/progress/progress'
import BProgressBar from 'bootstrap-vue/es/components/progress/progress-bar'
import { fetchAppleidQuantumult } from '@/api/appleid'
import { encode } from 'js-base64'
export default {
  components: {
    Modal,
    AppleContent,
    BProgress,
    BProgressBar
  },
  data() {
    return {
      appleinfo: '',
      loading: false,
      modal: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.server.account
    },
    subLinks_1() {
      return this.$store.state.subLinks_1
    },
    subLinks_2() {
      return this.$store.state.subLinks_2
    }
  },
  mounted() {
    this.loading = true
    this.getAccounts().then(res => {
      this.loading = false
    })
    this.getAppid()
  },
  methods: {
    ...mapActions(['getAccounts']),
    handleCopy(text, event) {
      clip(text, event)
    },
    getAppid() {
      this.loading = true
      fetchAppleidQuantumult().then(res => {
        this.appleinfo = res.data
        this.loading = false
      })
    },
    addSub(link) {
      location.href = `quantumult://configuration?server=${encode(link)}&filter=aHR0cHM6Ly9yYXcuZ2l0aHVidXNlcmNvbnRlbnQuY29tL3Nzc3RrL2x5cnVsZXMvbWFpbi9JTklUSUFMLmNvbmY=&rejection=aHR0cHM6Ly9yYXcuZ2l0aHVidXNlcmNvbnRlbnQuY29tL3Nzc3RrL2x5cnVsZXMvbWFpbi9SRUpFQ1QuY29uZg==`
    }
  }
}
</script>
<style>
.search-noresults img {
  max-width: 100%;
}
.appid {
  font-size: 14px;
}
.appid-hd {
  font-weight: bold;
  color: #333;
  display: inline-block;
  width: 80px;
}
.appid-account {
  line-height: 1.4;
  font-weight: bold;
  color: #333;
  margin-bottom: 6px;
}
/** iframe样式 */
#iframeContain {
  width: 100%;
  height: 240px;
}
</style>
